import UserStore from "./UserStore";
import SearchSessionStore from "./SearchSessionStore";
import EChainStore from "./EChainStore";
import AppStatusStore from "./AppStatusStore";
import TutorialStore from "./TutorialStore";
import HistoryStore from "./HistoryStore";
import SourceReferencesStore from "./SourceReferencesStore";
import { DEV, getConfig } from "../lib/configMgr";

const RESULTS_BATCH_SIZE = getConfig().resultsBatchSize || 500;
const appStatusStore = new AppStatusStore();
const userStore = new UserStore(appStatusStore);
const searchSessionStore = new SearchSessionStore(
  userStore,
  appStatusStore,
  RESULTS_BATCH_SIZE,
);
const eChainStore = new EChainStore(userStore, appStatusStore, searchSessionStore);
const tutorialStore = new TutorialStore({ userStore, appStatusStore, searchSessionStore, eChainStore });
const historyStore = new HistoryStore(userStore);
searchSessionStore.historyStore = historyStore;
const sourceReferencesStore = new SourceReferencesStore();

export const rootStore = {
  userStore,
  searchSessionStore,
  eChainStore,
  appStatusStore,
  tutorialStore,
  historyStore,
  sourceReferencesStore
};

// Expose rootStore for debugging in dev mode
if (DEV) {
  window.__rootStore = rootStore;
}
